import { useTranslation } from "react-i18next";
import ContentLoader from "react-native-easy-content-loader";
import { FAB } from "../FAB";

export type Props = {
	enabled?: boolean;
	isLoading?: boolean;
	isCollapsed?: boolean;
	label?: string;
	testId?: string;
	onPress: () => void;
};

export const QuickStudyButton = ({
	enabled = true,
	isLoading = false,
	isCollapsed = false,
	label,
	testId = "quick-study-button",
	onPress,
}: Props) => {
	const { t } = useTranslation();

	if (!enabled) {
		return null;
	}

	if (isLoading) {
		return (
			// @ts-ignore: react-native-easy-content-loader has no types
			<ContentLoader
				containerStyles={{
					paddingBottom: 10,
					paddingTop: 10,
				}}
				paragraphStyles={{
					borderRadius: 16,
					marginLeft: -10,
				}}
				pRows={1}
				title={false}
				pWidth={151.52}
				pHeight={56}
			/>
		);
	}

	return (
		<FAB
			icon="playlist-play"
			variant="primary"
			onPress={onPress}
			label={isCollapsed ? "" : (label ?? t("dashboard.header.quickStudy"))}
			testID={testId}
		/>
	);
};
